import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '4rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    code: {
      name: 'รหัส',
      width: '6rem',
    },
    name: {
      name: 'ชื่อสาขาย่อย',
      width: '1fr',
    },
    hubType: {
      name: 'ประเภท',
      width: '6rem',
      filter: (val: string) => {
        if (val === 'MAIN') return 'สาขาหลัก';
        return 'สาขาย่อย';
      },
    },
    // 'hubs.data.areas.name': {
    //   name: 'พื้นที่จัดส่ง',
    //   width: '6rem',
    // },
  },
  sortable: [
    'name',
  ],
};
